import React from "react";
import { Link } from "react-router-dom";
import { StyledHero } from "../components/Styled";
import hero from "../images/background1.jpg";
import data from "../data/data";

const Services = () => {
  const services = [...data.services];

  return (
    <div className="page-height services">
      <StyledHero image={hero}>
        <h3>Services</h3>
        <p>
          <Link to="/">Home</Link> / Services
        </p>
      </StyledHero>
      <div className="section-one">
        <p>What services will you get from me!</p>
      </div>
      <div className="section-two">
        {services.map((item, index) => (
          <div className="service-info" key={index}>
            <div className="icon">
              <span>
                <i className={item["icon-class"]}></i>
              </span>
            </div>
            <h3 className="title">{item.title}</h3>
            {item.description.map((desc, index) => (
              <p key={index}>{desc}</p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
